import type { FaireProductEntity } from "../../entity_types/product";

export const p_vy3wbesm98: FaireProductEntity = {
  token: "p_vy3wbesm98",
  type: "product",
  name: "Low Ball Glasses, Colorblock",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/d9bd87e7deb10a59d7c869e9b90e636aaa39117cf9584d4f3a667e907bdbc0f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c2d292479db85dfb0ac16e7cc964d3969e178dd95a38a523aac9f0bc9b2bed3.jpeg",
    "https://cdn.faire.com/fastly/b9f8c3fc68cc3cd2437e7fa7bd5f397b3ab7a05ac04734e4769d0869c1a1aabd.jpeg",
    "https://cdn.faire.com/fastly/df41e61d03ffd27840b07fb4c55f6b15bea42a5a3509afe2050553d4a03a58de.jpeg",
    "https://cdn.faire.com/fastly/3b01dbae2f723846c776972ac6d8bf0ba0ac6625bd7e6d425bdac8ef35bee98f.jpeg"
  ],
  priceDollars: 15.5,
  description: "Introducing the stars of your next party. These ban.do lowball glasses feature a colorful, eye-catching design that’s perfect for homemade cocktails, mocktails, or sparkling water. Equal parts functional and fun, they’ll make every pour feel like a celebration.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Set of 2 lowball glasses with vibrant, colorful designs\n• Made of high-quality glass for durability and style\n• Perfect for cocktails, mocktails, or everyday drinks\n• Dishwasher safe for easy cleanup\n• Designed in ban.do’s signature bright and joyful aesthetic\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and home décor boutiques\n• Lifestyle retailers and kitchenware stores\n• Bar carts, party hosts, and cocktail lovers\n• Wholesale buyers seeking fun, functional glassware",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:15.033Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
